// Events-page map (see konzepte/GOOGLE_MAPS_SETUP.md for cost/security
// setup). Public key, secured via HTTP-referrer + API restriction in the
// Cloud Console — not by hiding it, which isn't possible for a
// browser-loaded map anyway.
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

// Required for AdvancedMarkerElement (google.maps.Marker's replacement) —
// without a Map ID, the Map instance falls back to raster rendering and
// AdvancedMarkerElement throws. See konzepte/GOOGLE_MAPS_SETUP.md for how
// to create one (Cloud Console → Map Management → Map IDs).
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID;
